import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { OrgStructrureActionsComponent } from 'src/app/components/dialog/organization/org-structrure-actions/org-structrure-actions.component';
import { PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { ApiOrgStructuresService, DialogModalService, LanguageService, NotificationService } from 'src/app/services';

@Component({
  selector: 'app-structures-list',
  templateUrl: './structures-list.component.html',
  styleUrls: ['./structures-list.component.css']
})
export class StructuresListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  structures: any[] = [];
  departments: any;
  positions: any;
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;

  form: UntypedFormGroup = this.fb.group({
    department_id:[null],
    position_id: [null]
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiOrgStructure: ApiOrgStructuresService,
    private notification: NotificationService,
    private dialogModal: DialogModalService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getList();
    this.getDepartments();
    this.getPositions();

    this.form.get('department_id').valueChanges.subscribe(val => {

      this.getList();
    })

    this.form.get('position_id').valueChanges.subscribe(val => {
      console.log("VAL: ", val);
      
       this.getList();
    })

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.structures = [];

    this.setListParams();

    this.apiOrgStructure.getList(this.listParams).subscribe((response: Res) => { console.log('[RESPONSE] getList ORG STRUCRURE: ', response);
    
      
      if(response != null){

        if(response.result != null){
        
          this.structures = response.result.list;

          this.paginationInput = {
            count:          response.result.count,
            numberOfPages:  response.result.numberOfPages,
            currentPage:    this.listParams.pageNumber,
            size:           this.listParams.countOnPage
          }
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
    error => { 
      this.progressRef.complete();
      this.loading = false;
    });
  }


  
  /**
   * 
   */
   setListParams(): void {

    this.listParams = {
      filter: {
        department_id: this.form.get('department_id').value != null ? this.form.get('department_id').value : '',
        position_id: this.form.get('position_id').value != null ? this.form.get('position_id').value : ''
      },
      object: 'organization',
      pageNumber:  (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
   * 
   * @param searchValue 
   */
   getDepartments(searchValue: string = ''): void {

    this.progressRef.start();
    this.loading = true;

    let params = {
      "filter": {}
    }

    this.subscriptions.add(
      this.apiOrgStructure.getReferences(params, 'orgs_departments').subscribe((response: Res) => {

        if (response != null) {

          this.departments = response.result;
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }


  /**
   * 
   */
  getPositions(): void {

    this.progressRef.start();
    this.loading = true;


    let params = {
      filter: {
        get_all_positions: true
      }
    }

    this.subscriptions.add(
      this.apiOrgStructure.getReferences(params, 'orgs_positions').subscribe((response: Res) => {console.log("NAME: ", response);
      

        if (response != null) {

          this.positions = response.result;
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  /**
  * 
  * @param ids 
  */
  onConfirm(ids: string[]) {

    let message = 'Вы действительно хотите удалить?';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }
  /**
  * 
  * @param ids 
  */
   onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrgStructure.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  // deleteSelected(): void {

  //   let ids = [...new Set(this.organizations.filter(val => val.checked).map(({ id }) => id))];
  //   this.onDelete(ids);
  // }

  /**
   * 
   */
   onCreate() {

    this.dialogModal.open('', OrgStructrureActionsComponent).then(
      (result) => {
        console.log("RESULT: ", result);

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  
  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {
    
    this.paginationOutput = event;
    this.getList();
  }

}
